export default "__VITE_ASSET__r4ujhE8J__"